import React from 'react';

var ItemFilter = React.createClass({

    render: function(){

        //console.log(this.props.filterText.length);

        if ( this.props.filterText.length > 0 ) {

            return (
                <div className="item--filter">
                    <input className="item--filter--input" type="text" placeholder="Filter..."
                           value={this.props.filterText}
                           ref="filterTextInput"
                           onChange={this.handleChange} />
                    <i className="item--delete--icon fa fa-times" aria-hidden="true" onClick={ this.reset }></i>
                    <i className="item--filter--icon fa fa-search" aria-hidden="true"></i>
                </div>
            );

        }

        else {

            return (
                <div className="item--filter">
                    <input className="item--filter--input" type="text" placeholder="Filter..."
                           value={this.props.filterText}
                           ref="filterTextInput"
                           onChange={this.handleChange} />
                    <i className="item--filter--icon fa fa-search" aria-hidden="true"></i>
                </div>
            );

        }


    },

    reset : function() {

        console.log('clear');

        this.props.onUserInput('');

    },

    handleChange: function() {

        var component = this;

        component.props.onUserInput(
            this.refs.filterTextInput.value
        );


    },

});

export default ItemFilter;


/** WEBPACK FOOTER **
 ** ./app/ItemFilter.jsx
 **/